import { AuthenticationService } from './../../_services/authentication.service';
import { Component, OnInit, OnDestroy, Renderer2, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { LoggerService } from './../../_services/logger.service';
import { MenuService } from '../../_services/menu.service';
import { User } from '../../_models';
import { TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { BreadcrumbComponent } from '../../_shared/breadcrumb/breadcrumb.component';
import { AppHeaderComponent } from '../../_shared/app-header/app-header.component';
import { AppFooterComponent } from '../../_shared/app-footer/app-footer.component';
import { MenuAsideComponent } from '../../_shared/menu-aside';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterOutlet, AppHeaderComponent, AppFooterComponent, MenuAsideComponent, ToastrModule, BreadcrumbComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AdminComponent implements OnInit, OnDestroy {
  // Translate
  flag: string = "";
  flags = {
    "pt": "/assets/icon/flag/pt.svg",
    "en": "/assets/icon/flag/en.svg",
    "es": "/assets/icon/flag/es.svg"
  };

  public mylinks: Array<any> = [];
  public skin: string = 'skin-blue';
  public display_user = true;
  public display_tasks = true;
  public display_messages = true;
  public display_notifications = true;
  public display_menu_user = true;
  public display_menu_search = true;
  public header_components = [];
  public boxed_style = true;
  logger: LoggerService | undefined;
  user: User = new User();
  private menuSubscription = null;

  constructor(
    private menuService: MenuService,
    private router: Router,
    protected menuServ: MenuService,
    protected route: ActivatedRoute,
    protected authService: AuthenticationService,
    public translate: TranslateService,
    private renderer: Renderer2
  ) {
    const param = route.snapshot.data;

    this.skin = this.paramExistOrDefault(param, 'skin');
    this.display_user = this.paramExistOrDefault(param, 'display_user');
    this.display_tasks = this.paramExistOrDefault(param, 'display_tasks');
    this.display_messages = this.paramExistOrDefault(param, 'display_messages');
    this.display_notifications = this.paramExistOrDefault(param, 'display_notifications');
    this.display_menu_user = this.paramExistOrDefault(param, 'display_menu_user');
    this.display_menu_search = this.paramExistOrDefault(param, 'display_menu_search');
    this.header_components = this.paramExistOrDefault(param, 'header_components');
    this.boxed_style = this.paramExistOrDefault(param, 'boxed_style', true);

    // this.toastrConfig = new ToasterConfig({
    //   newestOnTop: true,
    //   showCloseButton: true,
    //   tapToDismiss: false
    // });

    this.initializeLanguage(translate);

    let storelang = localStorage.getItem("lang") || 'pt' || 'pt';
    this.translate.use(storelang);
  }

  private paramExistOrDefault(param: any, index: string, default_value = true) {
    return param.hasOwnProperty(index) ? param[index] : default_value;
  }
  public getLinks(): Array<any> {
    return this.mylinks;
  }

  urls = [
    '/revisao',
    '/revisao-classificação',
    '/revisao-diagramacao',
    '/revisao-documentos-nao-contratados'
  ];

  ngAfterViewInit(): void {

  }

  public ngOnInit(): void {
    // window.onload = () => {
    //   const loader = this.renderer.selectRootElement('#loader', true);
    //   this.renderer.setStyle(loader, 'display', 'none');
    // };
    this.router.events.subscribe((event: any) => {
      if(event instanceof NavigationEnd) {
        const loader = document.getElementById('loader');
        if(loader) {
          loader.style.display = 'none';
        }
      }
    });
    // console.log('admin layout init');
    this.user = this.authService.currentUserValue;
    const urlAtual = this.router.url;
    const urlEncaixa = this.urls.some((url: any) => urlAtual.startsWith(url));

    if(urlEncaixa) {
      this.display_notifications = false
      this.display_messages = false
      this.display_tasks = false
    }
    if(this.router.url == '/forbidden' || this.router.url == '/not-found' && this.user.profileRevisor == true) {
      this.display_notifications = false
      this.display_messages = false
      this.display_tasks = false
    }
    const ie = this.detectIE();
    if(!ie) {
      window.dispatchEvent(new Event('resize'));
    } else {
      // solution for IE from @hakonamatata
      const event = document.createEvent('Event');
      event.initEvent('resize', false, true);
      window.dispatchEvent(event);
    }

    // default menu structure, please use the menuService to modify
    // register to menu change

    document.body.className = 'hold-transition ' + this.skin + ' sidebar-mini ';
  }

  public ngOnDestroy(): void {
    document.body.className = '';
  }

  protected detectIE(): boolean {
    const ua: string = window.navigator.userAgent;
    return ua.includes('MSIE ') || ua.includes('Trident/') || ua.includes('Edge/');
  }

  initializeLanguage(translate: TranslateService) {
    let storelang: any = localStorage.getItem("lang");
    this.translate.use(storelang);
    this.flag = (this.flags as any)[storelang];
  }
}
